import { ChipSelect } from 'components/ChipSelect/ChipSelect'
import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'

interface Props {
  onChange: (count: IdeasCount) => void
  selectedCount: IdeasCount
}

export enum IdeasCount {
  XS = '5',
  S = '10',
  M = '15',
  L = '20',
}

export const NumberOfIdeasSelect = ({ onChange, selectedCount }: Props) => {
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const selectedLevel = [...selection][0]
    onChange(selectedLevel as IdeasCount)
  }

  const selectedKeys = selectedCount ? [selectedCount] : []

  return (
    <ChipSelect selectedKeys={selectedKeys} selectionMode="single" deletable={false} onSelectionChange={handleChange}>
      <Item key={IdeasCount.XS}>{IdeasCount.XS}</Item>
      <Item key={IdeasCount.S}>{IdeasCount.S}</Item>
      <Item key={IdeasCount.M}>{IdeasCount.M}</Item>
      <Item key={IdeasCount.L}>{IdeasCount.L}</Item>
    </ChipSelect>
  )
}
